import { styled } from '@mui/material';

export const Page = styled('div')`
  width: 100%;
  height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px;
  background: #f4f7fa;
`;

export const Wrapper = styled('div')`
  max-width: 1217px;
  max-height: 800px;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: space-between;
  flex-direction: column;
  gap: 24px;
`;

export const Header = styled('div')`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const Body = styled('div')`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  gap: 24px;
  text-align: center;
`;

export const Footer = styled('div')`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  gap: 24px;
  text-align: center;
`;

export const Contacts = styled('div')`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 60px;
  text-align: center;
`;
